// Fator de conversão de estoque: vem da retaguarda e diz quantas unidades de
// venda equivalem a 1 unidade de estoque no ERP. O Muven só exibe o valor.

export interface StockConversionDescription {
    hasConversion: boolean;
    label: string;
    // Título curto, para quando a frase completa vem logo abaixo
    title: string;
    // Uma linha, para ficar ao lado do rótulo
    short: string;
    hint: string;
}

const NO_CONVERSION_HINT = 'Informado pela retaguarda (ERP): 1 unidade no estoque de lá equivale a 1 unidade vendida nos canais. Estoque e venda usam a mesma unidade.'
const NOT_INFORMED_HINT = 'A retaguarda (ERP) não informou um fator. Considere que estoque e venda usam a mesma unidade.'

// Sem Intl: o Node 12 do projeto não traz o locale pt-BR completo
function formatRatio(value: number): string {
    return String(Math.round(value * 10000) / 10000).replace('.', ',')
}

export function hasStockConversion(ratio: number | string | null | undefined): boolean {
    const value = Number(ratio)

    return Number.isFinite(value) && value > 0 && value !== 1
}

export function describeStockConversion(ratio: number | string | null | undefined): StockConversionDescription {
    if (!hasStockConversion(ratio)) {
        return {
            hasConversion: false,
            label: 'Sem conversão (1:1)',
            title: 'Sem conversão (1:1)',
            short: Number(ratio) === 1 ? '1 un. no ERP = 1 un. vendida nos canais' : 'Fator não informado pelo ERP; considere 1:1',
            hint: Number(ratio) === 1 ? NO_CONVERSION_HINT : NOT_INFORMED_HINT,
        }
    }

    const value = formatRatio(Number(ratio))

    return {
        hasConversion: true,
        label: `1 un. na retaguarda = ${value} un. de venda`,
        title: `Fator de conversão ${value}`,
        short: `1 un. no ERP = ${value} un. vendidas nos canais`,
        hint: `Informado pela retaguarda (ERP): 1 unidade no estoque de lá equivale a ${value} unidades de venda. Se o estoque no canal não bater com o do ERP, a diferença de unidade pode ser o motivo.`,
    }
}
